// extracted by mini-css-extract-plugin
export var paginationContainer = "_8e-0";